angular.module('angus.services').service('hierarchyNodeLevelService', 
	['_', 'fluentRest', 'colDefService',
	function(_, fluentRest, colDefService) {
		'use strict';

		function getLevels(subscriberId, hierarchyType){
			return fluentRest.api().subscribers(subscriberId).hierarchy().levels().get({ hierarchyType: hierarchyType });
		}

		function getColumnDefinitions(subscriberId, hierarchyType, flatHierarchy){
			return getLevels(subscriberId, hierarchyType)
					.then(function(levels){
						var visibleLevels = _.sortBy(_.filter(levels, function(level){
							return level.hierarchyNodeCount > 0;
						}), 'hierarchyNodeLevelSequence');
						return _.map(visibleLevels, function(level, index){
							var name = level.hierarchyNodeLevelName;
							var camelName = name.camelize();
							var colId = 'hierarchy.' + camelName;
							var opts = {
								valueGetter: function(params){
									return params.data && params.data.hierarchy ? params.data.hierarchy[camelName] : params.field == colId ? params.key : '';
								}
							};

							if(!flatHierarchy){
								opts.rowGroupIndex = index;
								opts.hide = true;
							}

							return colDefService.createText(colId, name, colId, opts);
						});
					});
		}

		return {
			getDivision: function(subscriberId){
				return getLevels(subscriberId, 'division');
			},
			getDeliveryCenter: function(subscriberId){
				return getLevels(subscriberId, 'deliveryCenter');
			},
			getServiceCenter: function(subscriberId){
				return getLevels(subscriberId, 'serviceCenter');
			},
			getDivisionColDefs: function(subscriberId, flatHierarchy){
				return getColumnDefinitions(subscriberId, 'division', flatHierarchy);
			},
			getDeliveryCenterColDefs: function(subscriberId, flatHierarchy){
				return getColumnDefinitions(subscriberId, 'deliveryCenter', flatHierarchy);
			},
			getServiceCenterColDefs: function(subscriberId, flatHierarchy){
				return getColumnDefinitions(subscriberId, 'serviceCenter', flatHierarchy);
			}
		};
	}
]);
